import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { LineReveal } from "@/components/LineReveal";
import { Countdown } from "@/components/Countdown";

export const EmailCapture = ({ dark = true }) => {
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(true);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/drops/subscribe", { email, marketing_consent: consent });
      setDone(true);
      toast.success(
        data.status === "already_subscribed"
          ? "You're already on the list."
          : "You're on the list. First access to every drop."
      );
    } catch {
      toast.error("Please enter a valid email.");
    }
  };

  return (
    <section
      data-testid="drop-signup-section"
      className={`py-32 md:py-44 px-6 md:px-12 ${dark ? "bg-[#050505] text-white" : "bg-white text-black"}`}
    >
      <div className="max-w-4xl">
        <p className={`text-[10px] tracking-[0.35em] uppercase mb-8 ${dark ? "text-white/40" : "text-black/40"}`}>
          The October Sale — ends October 25
        </p>
        <Countdown dark={dark} />
        <LineReveal
          lines={["Be first", "through the door."]}
          className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[1.02] tracking-tight mb-14"
        />
        {done ? (
          <p data-testid="drop-signup-success" className="font-serif italic text-2xl opacity-70">
            Consider yourself on the inside.
          </p>
        ) : (
          <form onSubmit={submit} className="max-w-xl">
            <div className="flex items-end gap-4">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="YOUR EMAIL"
                data-testid="drop-email-input"
                className={`flex-1 bg-transparent border-b py-3 text-sm tracking-[0.2em] uppercase placeholder:opacity-40 focus:outline-none focus:border-current transition-colors ${
                  dark ? "border-white/30" : "border-black/30"
                }`}
              />
              <button
                type="submit"
                data-testid="drop-subscribe-button"
                className={`border p-3 transition-colors duration-300 ${
                  dark
                    ? "border-white/40 hover:bg-white hover:text-black"
                    : "border-black/40 hover:bg-black hover:text-white"
                }`}
                aria-label="Subscribe"
              >
                <ArrowRight size={18} strokeWidth={1.5} />
              </button>
            </div>
            <label
              className={`flex items-center gap-3 mt-5 cursor-pointer w-fit text-[10px] tracking-[0.2em] uppercase ${
                dark ? "text-white/50" : "text-black/50"
              }`}
            >
              <input
                type="checkbox"
                checked={consent}
                onChange={(e) => setConsent(e.target.checked)}
                data-testid="drop-consent-checkbox"
                className="accent-white w-3.5 h-3.5"
              />
              Email me when Drop 002 drops
            </label>
          </form>
        )}
      </div>
    </section>
  );
};
